import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
  },
  es: {
  },
};

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  silentFallbackWarn: true,
  messages, // set locale messages
});

export default i18n;
